var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDhlLogoRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 43.2533,
    viewBox: "0 0 196 43.2533",
    width: 196,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h196v43.2533h-196z",
    fill: "#fc0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d40511"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 29.901h26.506l-1.448 1.97h-25.058z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 26.245h29.199l-1.451 1.968h-27.748z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 33.56h23.815l-1.442 1.956h-22.373z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196 31.871h-26.402l1.447-1.969h24.955z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196 35.516-29.087.003 1.441-1.959h27.646z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.735 26.245h22.265v1.969l-23.713.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.6726 35.5163 12.5779-17.0888h15.6082c1.7252 0 1.7026.655.86 1.7975-.8562 1.16-2.3133 3.1547-3.1854 4.3323-.4426.5982-1.2431 1.6881 1.4089 1.6881h20.91c-1.739 2.3822-7.38 9.2709-17.5082 9.2709z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.7056 26.244-6.82 9.2723h-17.9926s6.8172-9.2709 6.8233-9.2709z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.7239 26.2454-6.8239 9.2709h-17.9857s6.8178-9.2709 6.8239-9.2709z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.5749 26.2454c.0006 0-1.3141 1.7975-1.9529 2.66-2.2593 3.0534-.2626 6.6105 7.111 6.6105h28.8853l6.8226-9.2709z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.4685 7.8007-6.2621 8.508h34.1289c1.7249 0 1.7023.655.8592 1.7974-.8562 1.1587-2.2894 3.1763-3.1614 4.3539-.4427.597-1.2432 1.6867 1.4089 1.6867h13.9564s2.25-3.0615 4.1352-5.6206c2.5655-3.4815.2225-10.7254-8.9486-10.7254z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.269 24.147h-44.007l12.034-16.346h17.986l-6.896 9.372h8.028l6.901-9.372h17.984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.2084 7.8007-12.0314 16.346h-19.0593s12.0355-16.346 12.0415-16.346z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhlLogoRgb);
export default __webpack_public_path__ + "static/media/DHL_logo_rgb.75af97046040ca2b3240f2c90bc8cc2b.svg";
export { ForwardRef as ReactComponent };